
import { defineComponent } from 'vue';
import AppHeader from '@/components/AppHeader.vue';
import AppSearch from '@/components/UI/AppSearch.vue';
import AddGroupMembers from '@/modules/spaces/components/AddGroup/AddGroupMembers.vue';

export default defineComponent({
  components: {
    AppHeader,
    AppSearch,
    AddGroupMembers,
  },
  props: {
    usersToAdd: { type: Array as () => string[], default: [] as string[] },
    usersToInvite: { type: Array as () => string[], default: [] as string[] },
  },

  emits: ['update-users', 'on-done'],

  setup(props, context) {
    function updateUsersToAdd(accountId: string) {
      context.emit('update-users', accountId);
    }

    function onDone() {
      context.emit('on-done');
    }

    return {
      updateUsersToAdd,
      onDone,
    };
  },
});
